// in src/MyAppBar.js
import * as React from "react";
import { AppBar } from "react-admin";
import { makeStyles, CssBaseline, Typography } from "@material-ui/core";
import LogoHeader from "./LogoHeader";
import HorizontalLogoHeader from "./HorizontalLogoHeader";
import { LocaleSwitcher } from "../../auth/LocaleSwitcher";

const useStyles = makeStyles({
  title: {
    marginLeft: 20,
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  spacer: {
    flex: 1,
  },
  locationGrid: {
    fontFamily: "Proxima-Nova,sans-serif,sans-serif",
    color: "#FFF",
    fontSize: "14px",
    position: "absolute",
    right: 133,
    top: 33,
    float: "right",
  },
  titlecontainer: {
    paddingTop: "0px",
  },
  spanSeparator: {
    fontSize: "18pt",
    fontFamily: "ProximaNova",
  },
  reactAdminTitleContainer: {
    paddingTop: "5px",
  },
  horizontalLogoHeader: {
    position: "absolute",
    right: 133,
    "@media (max-width: 760px)": {
      display: "none",
    },
  },
});

const HeaderBarLayout = (props) => {
  const classes = useStyles();
  return (
    <div style={{ paddingTop: "42px" }}>
      <AppBar {...props}>
        <CssBaseline />
        <div>
          <LogoHeader />
        </div>
        <div className={classes.titlecontainer}>
          <span className={classes.spanSeparator}>|</span>
        </div>
        <div className={classes.reactAdminTitleContainer}>
          <Typography variant="h6" color="inherit" className={classes.title} id="react-admin-title" />
        </div>
        <div className={classes.horizontalLogoHeader}>
          <HorizontalLogoHeader />
        </div>
        <div className={classes.locationGrid}>
          <LocaleSwitcher />
        </div>
        <span className={classes.spacer} />
      </AppBar>
    </div>
  );
};

export default HeaderBarLayout;
